import type { FocusFallbackListener } from '#src/app/shared/hooks/focus';

/**
 * Focus fallback for the decision-maker section. A Remove unmounts the focused button with its card, so focus
 * lands on the card that takes its place (or the new last one), on the empty message after the last Remove, or
 * on the section itself.
 */
export const decisionMakerFocusFallback: FocusFallbackListener = ({ container, focus }) =>
	focus(container.querySelector('[data-focus-target="decision-maker-current-slide"]')) ||
	focus(container.querySelector('[data-focus-target="decision-makers-empty"]')) ||
	focus(container);
